import { render } from "./Overview.vue?vue&type=template&id=2456b10b&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=2456b10b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2456b10b"]])

export default __exports__